function Cookies() {
  return (
    <div className="pagecontent textpage">
	  <p className="reveal"><b>Cookie Policy</b></p>
	  <p className="reveal"><b>Introduction</b><br />
	  This Cookie Policy explains how Blue Coast Capital uses cookies when you visit our website at <a href="http://www.bccap.com">www.bccap.com</a>.</p>
	  <p className="reveal"><b>What are cookies?</b><br />
	  Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners to make their websites work, or to work more efficiently, as well as to provide reporting information.</p>
	  <p className="reveal"><b>Types of cookies we use</b><br />
	  Below are the cookies we use which are all related to Google Analytics, none of these are essential cookies.</p>

<table className="cookietable reveal" cellspacing="0" cellpadding="0" border="0">
<tr><td valign="top">Cookie</td><td valign="top">_ga_*</td></tr>
<tr><td valign="top">Domain</td><td valign="top">.bccap.com</td></tr>
<tr><td valign="top">Description</td><td valign="top">Google Analytics sets this cookie to store and count page&nbsp;views.</td></tr>
<tr><td valign="top">Duration</td><td valign="top">1 year 1 month 4 days</td></tr>
<tr><td valign="top">Type</td><td valign="top">Analytics</td></tr>
</table>


		<p className="reveal"><b>How can I control cookies?</b><br />
		You have the right to decide whether to accept or reject cookies. You can exercise your cookie rights by setting your preferences in the Cookie Consent Manager. The Cookie Consent Manager allows you to select which categories of cookies you accept or reject. Essential cookies cannot be rejected as they are strictly necessary to provide you with services.</p>
		<p className="reveal"><b>Changes to this Cookie Policy</b><br />
		We may update this Cookie Policy from time to time to reflect, for example, changes to the cookies we use or for other operational, legal, or regulatory reasons. Please re-visit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.</p>
		<p className="reveal"><b>Contact us</b><br />
		If you have any questions about our use of cookies or other technologies, please email us at <a href="mailto:policy@bccap.com">policy@bccap.com</a></p>
    </div>
  );
}

export default Cookies;
